import React, {useEffect, useState} from 'react';
import {Button} from "../Button";
import {Can} from "../../../ability-context";
import CtaCannot from "../CtaCannot";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toastError} from "../../../libs/toast";
import { LIKE} from "../../../const/toasts";
import {createLike, deleteLike} from "../../../api/public-voissa/likes";
import {ARTICLE_KEY} from "../../../api/public-voissa/articles";
import {MEDIA_KEY} from "../../../api/public-voissa/medias";


const LikeBtn = ({
         isLiked = false,
         className = "",
         likeType = null,
         parentId = null
     }) =>{
    const queryClient = useQueryClient();
    const [toggleLike, setToggleLike] = useState(isLiked);


    const listConstMap = {
        "articles" : async () => {
            await queryClient.invalidateQueries([ARTICLE_KEY, parentId]);
            //await queryClient.invalidateQueries([USER_ARTICLES_KEY]);
        },
        "medias" : async () => {
            await queryClient.invalidateQueries([MEDIA_KEY, parentId]);
            //await queryClient.invalidateQueries([MEDIAS_KEY]);
        }
    }

    const {
        isLoading : isLoadingLike,
        mutate : mutateLike,
    } = useMutation(() => toggleLike ? createLike(likeType, parentId) : deleteLike(likeType, parentId),{
        onSuccess: async () =>{
            if(listConstMap[likeType]){
                await listConstMap[likeType]();
            }
        },
        onError: () =>{
            toastError(!toggleLike ? LIKE.ERROR.CREATE : LIKE.ERROR.DELETE);
            setToggleLike(!toggleLike);
        }
    });

    function handleToggleLike() {
        mutateLike();
        setToggleLike(!toggleLike);
    }

    useEffect(() => {
        setToggleLike(isLiked)
    }, [isLiked]);

    return(
        <Can action="create" subject="Like" passThrough>
            {can => {
                return can ? (
                    <Button
                        className={`btn-likes ${className || ""}`}
                        active={toggleLike}
                        onClick={() => handleToggleLike()}
                        icon={toggleLike ? "heart-full" : "heart-empty"}
                        content={"J'aime"}
                        disabled={isLoadingLike}
                        loading={isLoadingLike}
                    />
                ) : (
                    <div className={"w-100"}>
                        <CtaCannot action={"like"} isModal={true}  >
                            <Button
                                className={`btn-likes ${className || ""}`}
                                active={toggleLike}
                                icon={toggleLike ? "heart-full" : "heart-empty"}
                                content={"J'aime"}
                            />
                        </CtaCannot>
                    </div>
                )}}
        </Can>
    )
};

export default LikeBtn;